'use client';
import { Typography } from '@curology/ui-components-web/react/Typography';
import Image from 'next/image';
import React from 'react';

import { type PhotoResource } from '@/services/funnelService/types';

const ExamplePhoto = ({ photo }: { photo: PhotoResource }) => {
  const { imagesHeight, imagesWidth } = photo;

  return (
    <div className="cur-flex-1 cur-text-center">
      <div className="cur-pr-2">
        <Typography className="cur-mb-2" weight="bold">
          Example
        </Typography>
        <div
          className="cur-relative"
          style={{ paddingTop: `${(imagesHeight / imagesWidth) * 100}%` }}
        >
          <Image
            alt={photo.exampleImageAlt || 'Example image'}
            fill={true}
            src={photo.exampleImageUrl}
          />
        </div>
      </div>
    </div>
  );
};

export default ExamplePhoto;
